
export default {
  head: function () {
    return {
      title: Boolean(this.search && this.search.length > 2) ? `Результат поиска: ${this.search}` : 'Поиск',
    }
  },
  data: function () {
    return {
      headSections: [],
      contents: [],

      search: "",
      activeContent: "",

      timeOutSearch: null,
      isLoading: false
    }
  },

  computed: {
    pathGoBack: function () {
      if (!process.client) {
        return "/"
      }

      return Boolean((window.history?.length || 0) > 3) ? this.$nuxt.context.from.path : "/"
    }
  },

  watch: {
    search: function () {
      clearTimeout(this.timeOutSearch);

      this.isLoading = Boolean(this.search.length > 2);
      this.activeContent = "";
      this.contents = [];
      this.headSections = [];

      this.timeOutSearch = setTimeout( async () => {
        await this.getContent();
      }, 1000);
    }
  },

  components: {
    ElementLink: () => import("~/components/search/ElementLink.vue"),
    ElementProduct: () => import("~/components/search/ElementProduct.vue"),
  },

  mounted: async function () {
    const search = this.$route?.query?.data;
    if (!!search) {
      this.search = search;
      await this.getContent();
    }
  },

  methods: {
    getContent: async function () {
      if (this.search.length < 2) {
        return
      }

      let headSections = [];
      const results = await this.$api.agent.transport.get(`catalog/search?query=${this.search}&expand=characteristicGroup`).then((res) => {
        return res.data?.results || {}
      }).catch(() => {
        return {}
      });
      let contents = Object.keys(results)
        .map((key) => {
          const result = results[key];
          result.index = key;
          if (result.total <= 0) {
            return null
          }

          return  result
        })
        .filter((t) => !!t);

      contents = contents.map((content) => {
        let name = content?.name || "";
        if (content.index === "products") {
          name = content?.items?.[0]?.characteristicGroup?.name || content?.name;
        }

        headSections.push({
          index: content.index,
          name: name,
          total: content.total,
        });

        return {
          ...content,
          name
        }
      })

      this.contents = contents;
      this.headSections = headSections;
      this.isLoading = false;

      window.history.replaceState(null, null, `/search?data=${this.search}`);

      this.$refs.refSearchInput.blur();
    },
    mobileStartSearch: async function () {
      this.isLoading = Boolean(this.search.length > 2);
      this.activeContent = "";
      this.contents = [];
      this.headSections = [];
      await this.getContent();
    },
    changeActiveContent: function (index) {
      if (this.activeContent === index) {
        this.activeContent = "";
        return
      }
      this.activeContent = index;
    }
  }
}
